<import-file
  [title]="'Import Attachement'"
  [isGeneric]="false"
  [documentType]="documentType.ClaimContact"
  [attachmentId]="attachmentId"
>
</import-file>
